// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__b_ZYf","hide":"Banner_hide__TwPqw","termsnote":"Banner_termsnote__cznfH","quotation":"Banner_quotation__21Ad_","author":"Banner_author__51cW6"};